import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { CommonUtils, OverLayHiddenService } from '@farris/ui-common';
import { BehaviorSubject } from 'rxjs';
import { UtilService } from '../services/farris-datepicker.util.service';
import { MultiSelectedOrderBy } from '../interfaces/my-options.interface';

@Component({
    selector: 'multi-select-input',
    templateUrl: './multi-date-input.component.html',
    styles: [
        `
        .multi-date-display {
            width: 100%;flex-wrap: wrap;align-items: center;cursor: text;
        }

        .multi-date-display:empty:before {
            content: attr(placeholder);
            color: #c4c4c4;
        }

        .multi-date-display-readonly {
            padding-right: 5px;
        }

        .f-multi-select-date.f-state-disabled .search-tag-item {
            background: #F1F3F7;
            border: 1px solid #F1F3F7;
            color:  #2D2F33;
        }

        .f-multi-select-date.f-state-disabled .multi--more-text {
            color: #c7c7c7;
        }

        `
    ]
})

export class MultiSelectDateInputComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

    @Input() dates = '';
    @Input() separator = ',';
    @Input() placeholder = '';
    @Input() editable = true;
    @Input() orderBy: MultiSelectedOrderBy = 'none';

    @Output() clickHandle = new EventEmitter();
    @Output() remove = new EventEmitter();

    @ViewChild('searchbox2') shadowBox: ElementRef;
    @ViewChild('searchbox') container: ElementRef;

    _dateItems = [];

    hiddenItemsCount$ = new BehaviorSubject(0);
    commonUtils = null;

    constructor(private injector: Injector, private render: Renderer2, private el: ElementRef, public overLayService: OverLayHiddenService, protected cd: ChangeDetectorRef,
        private utilService: UtilService) {
        this.commonUtils = this.injector.get(CommonUtils, null);
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        if (this.overLayService) {
            this.overLayService.destory(this.shadowBox.nativeElement);
        }
        if (this.shadowBox) {
            this.shadowBox.nativeElement.remove();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.dates && !changes.dates.isFirstChange()) {
            this.initDateItems();
        }
    }

    private initDateItems() {
        const _dateItems = this.dates.split(this.separator).filter(n => n);
        if (_dateItems && _dateItems.length) {
            this._dateItems = this.utilService.orderSelectedDates(_dateItems, this.orderBy);
        } else {
            this._dateItems = [];
        }

        setTimeout(() => {
            this.setHiddenCount();
        });
    }

    ngAfterViewInit() {

        this.initDateItems();

        setTimeout(() => {
            this.moveShadowToBody();
        });
    }

    onClick($event: MouseEvent) {
        $event.stopPropagation();
        this.toggleShadowBox($event, false);
        this.clickHandle.emit($event);
    }

    onRemove($event: MouseEvent, txt, index) {
        if ($event) {
            $event.stopPropagation();
        }
        this.remove.emit({index, value: txt});
    }

    
    onResized($event) {
        this.updateShadowBoxPosition($event);
        setTimeout(() => {
            this.setHiddenCount();
            this.cd.detectChanges();
        });
    }


    private setHiddenCount() {
        let len = 0;
        if (!this._dateItems || !this._dateItems.length) {
            this.hiddenItemsCount$.next(len);
            return;
        }
        const items = Array.from(this.container.nativeElement.querySelectorAll('span.search-tag-item'));
        if (items && items.length) {
            len = items.map((n: any) => {
                return n.offsetTop;
            }).filter(n => n > 20).length
        }
        this.hiddenItemsCount$.next(len);
    }

    
    updateShadowBoxPosition({top, left, width} = {top: null, left: null, width: null}) {
        let bottom = 0;
        if (!top && !left && !width) {
            const e = this.el.nativeElement.getBoundingClientRect();
            top = e.top;
            left = e.left;
            width = e.width;
            bottom = e.bottom;
        }
        this.render.setStyle(this.shadowBox.nativeElement, 'left', left + 'px');
        this.render.setStyle(this.shadowBox.nativeElement, 'top', top + 'px');
        this.render.setStyle(this.shadowBox.nativeElement, 'width', width + 'px');

        // tfs 638279 638096
        const h = window.innerHeight - bottom;
        const iconPos = (isstart, top) => {
            if (this.shadowBox.nativeElement.querySelector('.input-group-append')) {
                this.render.setStyle(this.shadowBox.nativeElement.querySelector('.input-group-append'), "align-items", isstart?'start': 'end');
                this.render.setStyle(this.shadowBox.nativeElement.querySelector('.input-group-append button'), "top", top);
            }
        }

        if (h > top && top > 300) {
            this.render.setStyle(this.shadowBox.nativeElement, 'max-height', h + 'px');
            this.render.setStyle(this.shadowBox.nativeElement, 'top', top + 'px');
            this.render.removeStyle(this.shadowBox.nativeElement, 'bottom');
            iconPos(true, '4px');
        }
        else {
            if (h > 300) {
                this.render.setStyle(this.shadowBox.nativeElement, 'max-height', (h - 10) + 'px');
                this.render.setStyle(this.shadowBox.nativeElement, 'top', (top) + 'px');
                this.render.removeStyle(this.shadowBox.nativeElement, 'bottom');
                iconPos(true, '4px')
            } else {
                this.render.setStyle(this.shadowBox.nativeElement, 'max-height', (top - 10) + 'px');
                this.render.setStyle(this.shadowBox.nativeElement, 'bottom', (h) + 'px');
                this.render.removeStyle(this.shadowBox.nativeElement, 'top');
                iconPos(false, '-2px')
            }
        }

        this.render.setStyle(this.shadowBox.nativeElement, 'zIndex', this.commonUtils.getFloatingLayerIndex());
    }

    private moveShadowToBody() {
        this.updateShadowBoxPosition();
        document.body.append(this.shadowBox.nativeElement);

        this.overLayService.registerMouseEvent(this.shadowBox.nativeElement, (e) => {
            if (e.target && e.target.className && e.target.className.indexOf && e.target.className.indexOf('search-box_delete-keys') > -1) {
                return;
            }

            if (!this.shadowBox || this.shadowBox.nativeElement.contains(e.target)) {
                return;
            }

            this.toggleShadowBox(null, false);
        });

    }

    toggleShadowBox($event, show = true) {
        if ($event) {
            $event.stopPropagation();
        }
        if (!this.hiddenItemsCount$.value) {
            show = false;
        }
        if (show) {
            this.updateShadowBoxPosition();
            this.render.removeStyle(this.shadowBox.nativeElement, 'display');
            this.container.nativeElement.style.visibility = 'hidden';
        } else {
            this.container.nativeElement.style.visibility = 'visible';
            this.render.setStyle(this.shadowBox.nativeElement, 'display', 'none');
        }
    }
}